// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import apps from './apps'
import notifications from './notifications'

const rootReducer = {
  auth,
  navbar,
  layout,
  apps,
  notifications
}

export default rootReducer
